export default __webpack_public_path__ + "static/media/calendar.663a80ca.svg";